import { motion } from "framer-motion";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { profileData } from "../data/profileData";
import { BsPatchCheck } from "react-icons/bs";

const Certifications = () => {
	const { ref, inView } = useScrollAnimation();

	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: { staggerChildren: 0.1 },
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, x: -20 },
		visible: {
			opacity: 1,
			x: 0,
			transition: { duration: 0.5 },
		},
	};

	return (
		<section id="certifications" className="section-card" ref={ref}>
			<motion.div
				initial="hidden"
				animate={inView ? "visible" : "hidden"}
				variants={containerVariants}
			>
				<motion.div className="section-header" variants={itemVariants}>
					<span>Certifications</span>
					<h2>Achievements & awards</h2>
				</motion.div>
				<motion.ul className="certification-list" variants={containerVariants}>
					{profileData.certifications.map((item) => (
						<motion.li key={item} variants={itemVariants} className="certification-item">
							<BsPatchCheck className="certification-icon" />
							<span>{item}</span>
						</motion.li>
					))}
				</motion.ul>
			</motion.div>
		</section>
	);
};

export default Certifications;
